import React from "react";
import "./Product.css";
import {
  FaQrcode,
  FaUtensils,
  FaHotel,
  FaHospital,
  FaChartLine,
  FaMobileAlt,
  FaCreditCard,
  FaBell,
} from "react-icons/fa";

const features = [
  {
    icon: <FaQrcode />,
    title: "QR Ordering",
    desc: "Customers scan a QR code to browse, order, and pay instantly.",
  },
  {
    icon: <FaMobileAlt />,
    title: "Digital Dashboard",
    desc: "Manage orders, requests, and operations from one place.",
  },
  {
    icon: <FaChartLine />,
    title: "Smart Analytics",
    desc: "Track sales, customer behaviour, and business performance.",
  },
  {
    icon: <FaCreditCard />,
    title: "Online Payments",
    desc: "Offer secure and seamless digital payment options.",
  },
  {
    icon: <FaBell />,
    title: "Instant Notifications",
    desc: "Real-time updates for customers and staff.",
  },
  {
    icon: <FaMobileAlt />,
    title: "Multi-Location",
    desc: "Manage multiple branches with one centralized platform.",
  },
];

const industries = [
  {
    icon: <FaUtensils />,
    title: "Restaurants",
    desc: "QR menu, ordering, kitchen display, and digital payments.",
  },
  {
    icon: <FaHotel />,
    title: "Hotels & Hospitality",
    desc: "Room service, housekeeping, concierge, and guest requests.",
  },
  {
    icon: <FaHospital />,
    title: "Hospitals",
    desc: "Patient requests, meal ordering, housekeeping, and support.",
  },
];

const Scan2Order = () => {
  return (
  
<div className="backdiv">
 <section className="scan-hero">

         <video
            className="zweedo_video"
            src="/scan2order.mp4"
            autoPlay
            muted
            loop
            playsInline
          />

     
</section>
      <section className="product-section">
          <h2 className="product-heading">
            Smart Ordering. Smarter Operations.
          </h2>

          <p className="main_content">
            Scan2Order is an all-in-one digital platform that enables customers,
            guests, and patients to access services through a simple QR code.
            From ordering food to requesting housekeeping or patient support,
            every request is managed in real time through one powerful dashboard.
          </p>

      </section>

      <section className="product-section">
         <h2 className="product-heading">Industries We Serve</h2>
          <div className="prod-grid">
            {industries.map((item, index) => (
              <div key={index}>
                <div className="industry-box">
                  <div className="industry-icon">
                    {item.icon}
                  </div>
                  <h4>{item.title}</h4>
                  <p className="main_content text-center">{item.desc}</p>
                </div>
              </div>
            ))}

          </div>
      </section>

      <section className="product-section">

            <h2 className="product-heading">How It Works</h2>

          <div className="work-grid">

            {[
              "Scan QR",
              "Browse",
              "Order / Request",
              "Staff Receives",
              "Fulfilment",
              "Complete",
            ].map((step, i) => (
              <div key={i}>
                <div className="step-box text-center">
                  <div className="step-number">{i + 1}</div>
                  <h6>{step}</h6>
                </div>
              </div>
            ))}

          </div>

      </section>

      <section className="product-section">
            <h2 className="product-heading">
              Powerful Features
            </h2>
          <div className="prod-grid">

            {features.map((feature, index) => (
          
                <div className="feature-card"  key={index}>

                  <div className="feature-icon">
                    {feature.icon}
                  </div>

                  <h5>{feature.title}</h5>

                  <p className="main_content">{feature.desc}</p>

                </div>
          
            ))}

          </div>
      </section>


      <section  className="product-section">
            <h2 className="product-heading">
              Why Choose Scan2Order?
            </h2>
          <div className="scan2-grid">

            <div>
              <ul className="scan-list">
                <li>✔ Faster Service & Response Time</li>
                <li>✔ Contactless Customer Experience</li>
                <li>✔ Reduce Operational Costs</li>
                <li>✔ Increase Staff Productivity</li>
              </ul>
            </div>

            <div>
              <ul className="scan-list">
                <li>✔ Real-Time Dashboard</li>
                <li>✔ Smart Analytics & Reports</li>
                <li>✔ Secure Online Payments</li>
                <li>✔ Multi-Location Management</li>
              </ul>
            </div>

          </div>


      </section>

      </div>

 
  );
};

export default Scan2Order;